export default __webpack_public_path__ + "static/media/exitMenu.38a1be60.svg";